import React, { useContext, useEffect, useState } from "react";
import InnerLayout from "../../components/layouts/inner-layout";
import { DataContext } from "../../components/layouts/main-layout";
import { useNavigate, useParams } from "react-router-dom";
import { Form, Formik } from "formik";
import InputField from "../../components/forms/input-field";
import LoadingSpinner from "../../components/helper-components/loading-spinner";
import { api } from "../../redux/apis/api";
import errorToast from "../../components/helper-components/error-toast";
import moment from "moment";

const ViewUserCreation = () => {
  const { permissionFn } = useContext(DataContext);
  const navigate = useNavigate();
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get(`/cpos/app/user/getById?store_app_user_id=${id}`)
      .then((res) => {
        console.log("view user response:", res.data);
        const data = res.data?.data ?? res.data;
        setUser(Array.isArray(data) ? data[0] : data);
        setLoading(false);
      })
      .catch((err) => {
        console.log("view user error:", err?.response);
        errorToast(err?.response?.data?.message ?? "Failed to fetch user");
        setLoading(false);
      });
  }, [id]);

  if (loading) return <LoadingSpinner />;

  if (!user) {
    return (
      <InnerLayout permissionFn={permissionFn} module="store_execution_process" title="User Details">
        <div className="px-10 pt-8 text-gray-400 text-sm">User not found.</div>
      </InnerLayout>
    );
  }

  const initialValues = {
    user_name: user.user_name ?? "",
    store_app_use_phone_number: user.store_app_use_phone_number ?? "",
    created_date: user.created_date ? moment(user.created_date).format("DD/MM/YYYY") : "--",
  };

  return (
    <InnerLayout permissionFn={permissionFn} module="store_execution_process" title="User Details">
      <Formik enableReinitialize initialValues={initialValues} onSubmit={() => {}}>
        {() => (
          <Form className="h-full flex flex-col justify-between">
            <div className="w-full 2xl:w-[40%] xl:w-[50%] lg:w-[60%] px-5 xl:px-10 pt-5">
              <InputField type="text" name="user_name" label="User Name" labelWidth="10.5rem" isDisabled={true} />
              <InputField type="text" name="store_app_use_phone_number" label="Phone Number" labelWidth="10.5rem" isDisabled={true} />
              <div className="flex items-center mb-2" style={{ minHeight: "3rem" }}>
                <span
                  className="text-[var(--input-label-color)] text-[length:var(--input-label-font-size)] font-[var(--input-label-font-weight)] shrink-0"
                  style={{ minWidth: "10.5rem" }}
                >
                  Status
                </span>
                {user.user_status === "Active" ? (
                  <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs fw_500 bg-green-100 text-green-700">
                    <span className="w-[6px] h-[6px] rounded-full bg-green-500" />
                    Active
                  </span>
                ) : (
                  <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs fw_500 bg-gray-100 text-gray-500">
                    <span className="w-[6px] h-[6px] rounded-full bg-gray-400" />
                    {user.user_status ?? "--"}
                  </span>
                )}
              </div>
              <InputField type="text" name="created_date" label="Created Date" labelWidth="10.5rem" isDisabled={true} />
            </div>
            <div className="flex justify-start px-10 bg-white py-4 invoice-bottom-container" style={{ bottom: 0 }}>
              <button
                type="button"
                onClick={() => navigate("/user-creation")}
                className="px-6 py-2 rounded-md bg-primary text-white text-sm fw_500 hover:opacity-90"
              >
                Back
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </InnerLayout>
  );
};

export default ViewUserCreation;